import React, { FC } from "react";
import { CircularProgress, Flex } from "@evergis/ui";

export const ContainerLoading: FC = () => (
  <Flex
    style={{
      position: "absolute",
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <CircularProgress diameter={3} />
  </Flex>
);
